import { useMemo } from 'react';
import { PackageSessionResponse } from '~/types/api';
import summaryRoomTypesStyles from '~/styles/bookingFlow/summary-room-types.module.css';
import useTranslation from '~/hooks/useTranslation';
import IconBed from '~icons/tabler/bed';

type Props = {
  roomTypes: PackageSessionResponse['room_types'];
  roomTypesSelected: PackageSessionResponse['room_types_selected'];
};

export default function SummaryRoomTypes({
  roomTypes,
  roomTypesSelected,
}: Props) {
  const translate = useTranslation();

  const rooms = useMemo(() => {
    return roomTypesSelected
      .map((roomTypeSelected) => {
        const roomTypeName = roomTypes
          .find((roomType) => roomType.service_code === roomTypeSelected.service_code)?.name;

        return roomTypeName;
      })
      .filter((roomTypeName) => roomTypeName !== undefined);
  }, [roomTypes, roomTypesSelected]);

  return (
    <div>
      <h2 className={summaryRoomTypesStyles.heading}>
        {translate('bookingFlow.summary.rooms')}
      </h2>

      <ul className={summaryRoomTypesStyles.list}>
        {rooms.map((room, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${room}-${index}`} className={summaryRoomTypesStyles.listItem}>
            <IconBed />
            {room}
          </li>
        ))}
      </ul>
    </div>
  );
}
